




import {Vue, Component, Prop} from 'vue-property-decorator'
import CountryList from '../lib/kepler/countries'
import AutoComplete from './proxy/Inputs/AutoComplete.vue'
@Component({
  components: {AutoComplete},
})
export default class CountrySelector extends Vue {
  @Prop() public readonly label!: string
  @Prop() public readonly rules!: any[]

  public countries = CountryList

  protected input(e: string) {
    this.$emit('input', e)
  }
}
